import { autoRegisterFeature } from '@store/features/factory';

import { jotcoachFeature } from './store/feature';

autoRegisterFeature(jotcoachFeature);

export * from './components';
export * from './store';
export * from './types';
